/**
 * Created by vlad on 26.12.18.
 */

const ColorContainerCellView = BaseCellView.extend({
    ctor: function (containerCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        const bundle = containerCell.bundleId();
        if (containerCell.isForGoal) {
            this.image = new cc.Sprite(bundles[bundle].frames[`${bundle}_goal`]);
            this.addChild(this.image);
            this.image.setAlignment(this.width / 2, this.height / 2);
        } else {
            this.animation = new cleverapps.Spine(bundles[bundle].jsons[`${bundle}_json`]);
            this.addChild(this.animation);
            this.animation.setAlignment(this.width / 2, this.height / 2);
            if (containerCell.boomColor) {
                this.setColor(containerCell.boomColor);
                this.animation.setAnimation(0, `bottle_${containerCell.lives}`, true);
            } else {
                this.animation.setSkin("blue");
                this.animation.setAnimation(0, "bottle_2", true);
            }
        }

        this.initialize(containerCell);
    },

    initialize: function (containerCell) {
        this._super(containerCell);

        containerCell.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
        containerCell.onSetColor = this.createListener(this.setColor.bind(this));
    },

    setColor: function (color) {
        this.animation.setSkin(ColorComponent.CODE_COLORS[color]);
    },

    changeLives: function () {
        this.animation.setAnimation(0, `bottle_${this.cell.lives}_up`, false);
        this.animation.setCompleteListener(() => {
            this.animation.setAnimation(0, `bottle_${this.cell.lives}`, false);
        });

        const bundle = this.cell.bundleId();
        cleverapps.effects.fire(`match3.${bundle}.fill`);
    },

    startExploding: function (goal, idInGroup, params) {
        const bundle = this.cell.bundleId();
        cleverapps.effects.fire(`match3.${bundle}.collect`);
        this.startExplodingViaCollect(goal, idInGroup, params);
    }
});